<template>
    <div class="container">
        <div class="title">本期应收款费用</div>
        <Spin size="large" fix v-if="loading" />
        <Row :gutter="20" class="container-bill" v-else>
            <Col span="12" v-for="(item, index) in list" :key="index">
                <div class="container-bill-item">
                    <div class="text">
                        {{ item.feeTypeText }}:
                        {{ (item.price / 100) | currency }}元
                    </div>
                    <tag-status
                        :text="item.billStatusText"
                        :color="item.billStatusColor"
                        :background="item.billStatusBgc"
                        circle
                        style="line-height: 20px"
                    />
                </div>
            </Col>
        </Row>
    </div>
</template>
<script>
import TagStatus from "_vc/tag-status";
export default {
    components: { TagStatus },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="less" scoped>
.container {
    width: 100%;
    .title {
        background-color: #f8f8f9;
        height: 40px;
        line-height: 40px;
        padding: 0px 10px;
    }
    &-bill {
        &-item {
            display: flex;
            flex-wrap: wrap;
            padding: 0px 10px;
            align-items: center;
            line-height: 40px;
            .text {
                flex-grow: 1;
            }
        }
        &-item + &-item {
            margin-left: 20px;
        }
    }
}
</style>
